// initSdk.ts
import { AlertsWebSocketClient } from '../core/connectionPoolAlerts';
export async function initAlertSdk() {
    const client = new AlertsWebSocketClient("wss://logs.ysafe.io");
    return client;

}
